export enum ErrorType {
    IncorrectVerification = 'incorrectVerification',
    TooManyVerifications = 'tooManyVerifications',
    SessionNotFound = 'sessionNotFound',
}
